import { queryOptions, useQuery } from '@tanstack/react-query'
import { getTags } from '../services/getTags.service'

export const tagsQueryOptions = () =>
  queryOptions({
    queryKey: ['tags'],
    queryFn: getTags,
  })

export function useTags() {
  return useQuery(tagsQueryOptions())
}
